<template>
  <div>
    <div v-if="value">
      <slot
        name="selection"
        :remove="remove"
        :valueLabel="valueLabel"
        :value="value"
      >
        <d-chip
          :disabled="disabled"
          :closable="!disabled"
          class="is-shadowless"
          @close="remove()"
        >
          <span>{{ valueLabel }}</span>
        </d-chip>
      </slot>
    </div>
    <b-autocomplete
      v-else
      ref="autocomplete"
      v-model="query"
      autocomplete
      :data="data"
      :icon="icon"
      :placeholder="placeholder"
      :field="field"
      :maxlength="maxlength"
      :open-on-focus="openOnFocus"
      :keep-first="keepFirst"
      :disabled="disabled"
      :loading="isFetching"
      :check-infinite-scroll="true"
      @select="onInput"
      @infinite-scroll="onScrollBottom"
      @typing="onTyping"
    >
      <div slot-scope="props">
        <slot v-bind="props">
          {{ getLabel(props.option) }}
        </slot>
      </div>
      <template slot="footer">
        <slot name="footer" />
      </template>
      <template slot="empty">
        {{ $t('no_data') }}
      </template>
    </b-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: null,
      validator (value) {
        return _.isString(value) || _.isObject(value);
      }
    },
    route: {
      required: true,
      type: String
    },
    field: {
      default: undefined,
      type: String
    },
    icon: {
      default: "magnify",
      type: String
    },
    maxlength: {
      type: Number,
      default: undefined
    },
    openOnFocus: {
      type: Boolean,
      default: false
    },
    keepFirst: {
      type: Boolean,
      default: false
    },
    parameters: {
      default () {
        return {};
      },
      type: Object
    },
    placeholder: {
      default: null,
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      query: "",
      page: 0,
      stopScroll: false,
      data: [],
      isFetching: false
    };
  },
  computed: {
    valueLabel () {
      return this.getLabel(this.value);
    },
  },
  watch: {
    value (value) {
      if (!value) {
        this.query = "";
      }
    }
  },
  created () {
    if (this.openOnFocus) {
      this.fetch();
    }
  },
  methods: {
    onTyping (query) {
      this.query = query;
      this.page = 1;
      this.stopScroll = false;
      this.$emit("typing", query);
      this.getAsyncData();
    },
    getAsyncData: _.debounce(function () {
      if (!_.isString(this.query) || !this.query.length) {
        this.data = [];
        return;
      }
      this.fetch();
    }, 500),
    onScrollBottom () {
      this.page++;
      if (this.stopScroll == false) {
        this.fetch();
      }
    },
    fetch () {
      this.isFetching = true;

      let internalParameters = {
        page: this.page,
        search: this.query
      };

      let params = _.merge(internalParameters, this.parameters);

      this.$http.get(`${this.route}`, {
        params: params
      })
        .then(({ data }) => {
          if (this.page == 1) {
            this.data = [];
          }

          let items = data;
          if (_.isObject(items)) {
            items = items.data;
          }

          items.forEach((item) => this.data.push(item));

          if (items.length == 0) {
            this.stopScroll = true;
          }
        })
        .catch((error) => {
          this.data = [];
          throw error;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },
    onInput (event) {
      this.$emit("input", event);
    },
    remove () {
      this.onInput(null);
    },
    getLabel (option) {
      if (_.isString(option)) {
        return option;
      }
      return option[this.field];
    }
  }
};
</script>
